import React, { useEffect, useState } from "react";
import { CardContent, CardWrapper, MainDiv, MainSection } from "./elements";

import { Image } from "react-bootstrap";
import { heroimg2, heroimg3, heroimg4 } from "../../../assets";

import NavbarComp from "../navbar";

const HeroComp = () => {
  return (
    <MainDiv>
      <NavbarComp />
      <Image src={heroimg4} className="hero-img4" />
      <MainSection>
        <CardWrapper>
          <Image src={heroimg3} className="img-div" />
          <Image src={heroimg2} className="img-div2" />

          <CardContent>
            <h1>RETROCRAFT</h1>
            <p>
              Mint & Dive into <span>RetroCraft</span>'s NFT GameFi Adventure!
            </p>
          </CardContent>
        </CardWrapper>
      </MainSection>
    </MainDiv>
  );
};

export default HeroComp;
